<template>
    <div class="user-count" v-show="show">
        <div class="room-group" v-for="(item,index) in personGroup" :key="index">
            <!--<div class="room-index">房间 {{index + 1}}</div>-->
            <div style="padding: 10px">
                <div class="user-count-item">
                    <input-number v-model="item.adt" :min="1"></input-number>
                    <span> {{$t('adult')}}</span>
                </div>
                <div class="user-count-item">
                    <input-number v-model="item.chd" @plus="plusAge(item.Age)" @minus="minusAge(item.Age)"></input-number>
                    <span> {{$t('child')}}
                        <span style="font-size: 12px;color: #767676">(2-12{{$t('age')}})</span>
                    </span>
                </div>
                <div class="room-group" style="background-color: rgba(246,246,246,1);" v-for="(i,id) in item.Age" :key="id">
                    <div class="user-count-item" >
                        <input-number v-model="i.Age" :min="2" :max="12" :selectIcon="false" ></input-number>
                        <span>{{$t('age_name')}}</span>
                    </div>
                </div>
                <div class="user-count-item">
                    <input-number v-model="item.inf"></input-number>
                    <span> {{$t('infant')}}
                        <span style="font-size: 12px;color: #767676">(&lt;2{{$t('age')}})</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputNumber from '@/components/Inputnumber.vue'
export default {
    name: 'persionMenu',
    components: {
        InputNumber
    },
    data() {
        return {
            personGroup: [
                {
                    adt:1,
                    chd:0,
                    inf:0,
                    Age:[],
                }
            ]
        }
    },
    watch: {
        personGroup: {
            deep: true,
            handler: function(val) {
                this.$emit('i-select', val);
            }
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        //增加指定儿童的年龄
        plusAge(item){
            item.length < 5 ? item.push({Age:8}) : item
        },
        //减少指定儿童的年龄
        minusAge(item){
            item.length > 0 ? item.pop() : item
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/fonts/iconfont.css";
@import "../../../sass/variables";
.user-count {
    background: #FFFFFF;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26), 0 2px 10px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 50px;
    // bottom: 40px;
    left: 0;
    // right: 145px;
    // bottom: 90px;
    width: 190px;
    font-size: 14px;
    color: $black;
    .user-count-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 32px;
    }
    em {
        font-style: normal;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/AirTicket/components/PersionMenu.vue